// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-site-map-table-new .site-map-table-container {
  border-radius: 4px;
  margin: 24px 13px;
  border: none;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.1490196078);
}
.fi-site-map-table-new .site-map-table-container.no-border {
  box-shadow: none;
  margin: 0;
}
.fi-site-map-table-new .parent-container {
  height: 56px;
  line-height: 56px;
  font-size: 16px;
  transition: all 0.2s;
}
.fi-site-map-table-new .empty-list-dropzone-fallback {
  position: absolute;
  top: 0;
  width: 100%;
  height: 56px;
}
.fi-site-map-table-new .empty-list-dropzone-fallback.relative-position {
  position: relative;
  width: 100%;
  top: unset;
  min-height: 0px;
  height: unset;
  margin: 0;
  z-index: 2;
}
.fi-site-map-table-new .empty-list-dropzone-fallback.relative-position:hover {
  min-height: 56px;
}
.fi-site-map-table-new .empty-list-dropzone-fallback.origin-dropzone-fallback {
  min-height: 4px !important;
}

.dndPlaceholder {
  background: var(--fi-color-grey-light);
  min-height: 56px;
  max-height: 56px;
  min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/site-map/site-map-edit/site-map-table-new/site-map-table-new.component.scss"],"names":[],"mappings":"AAII;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,qDAAA;AAHR;AAKQ;EACI,gBAAA;EACA,SAAA;AAHZ;AAOI;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AALR;AAQI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AANR;AAOQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AALZ;AAMY;EACI,gBAAA;AAJhB;AAOQ;EACI,0BAAA;AALZ;;AAUA;EACI,sCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAPJ","sourcesContent":[".fi-site-map-table-new {\r\n    // [hidden] {\r\n    //   display: none;\r\n    // }\r\n    .site-map-table-container {\r\n        border-radius: 4px;\r\n        margin: 24px 13px;\r\n        border: none;\r\n        box-shadow: 0 1px 3px 1px #00000026;\r\n\r\n        &.no-border {\r\n            box-shadow: none;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    .parent-container {\r\n        height: 56px;\r\n        line-height: 56px;\r\n        font-size: 16px;\r\n        transition: all 0.2s;\r\n    }\r\n\r\n    .empty-list-dropzone-fallback {\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 56px;\r\n        &.relative-position {\r\n            position: relative;\r\n            width: 100%;\r\n            top: unset;\r\n            min-height: 0px;\r\n            height: unset;\r\n            margin: 0;\r\n            z-index: 2;\r\n            &:hover {\r\n                min-height: 56px;\r\n            }\r\n        }\r\n        &.origin-dropzone-fallback {\r\n            min-height: 4px !important;\r\n        }\r\n    }\r\n}\r\n\r\n.dndPlaceholder {\r\n    background: var(--fi-color-grey-light);\r\n    min-height: 56px;\r\n    max-height: 56px;\r\n    min-width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
